import React, { useState } from "react";
import { Button, Table, Form, Row, Col } from "react-bootstrap";
import CustomTooltip from "utils/CustomTooltip";
import { v4 as uuidv4 } from "uuid";
import CustomSwitch from "utils/CustomSwitch";
import PointsofContact from "../PointsOfContact";
import CustomFormCheck from "utils/CustomFormCheck";
import jsDig from "utils/jsDig";

export default function Agreement(props) {
  let ppcFeeStructure = jsDig(["billing_config", "ppc_fee_structure"], props);
  let ppcFees = jsDig(["billing_config", "ppc_fees"], props);
  const [ppcFeesStructure, setPPCFeesStructureDetail] = useState(
    ppcFeeStructure && ppcFeeStructure.length > 0
      ? ppcFeeStructure
      : [
          {
            id: uuidv4(),
            flat_fee: "0",
            over_ad_spend: "0",
            percentage_fee: "0",
            flat_fee_enabled: "0",
            percentage_fee_enabled: "0",
            percentage_fee_total_over: "total",
          },
        ]
  );
  const [ppcFeesDetail, setPPCFeesDetail] = useState(
    ppcFees ? ppcFees : [{ id: uuidv4(), label: "", amount: "0", status: "0", enabled: "0", status: "Recurring", frequency: "Monthly" }]
  );
  const handleAddPPCFee = (event) => {
    let newArray = ppcFeesDetail;
    newArray.push({ id: uuidv4(), label: "", amount: "0", status: "0", enabled: "0", status: "Recurring", frequency: "Monthly" });
    setPPCFeesDetail([...newArray]);
  };
  const handleAddStructure = (event) => {
    let newArray = ppcFeesStructure;
    newArray.push({
      id: uuidv4(),
      flat_fee: "0",
      over_ad_spend: "0",
      percentage_fee: "0",
      flat_fee_enabled: "0",
      percentage_fee_enabled: "0",
      percentage_fee_total_over: "total",
    });
    setPPCFeesStructureDetail([...newArray]);
  };
  const handleDeleteStructure = (i) => {
    let remain = ppcFeesStructure.filter((fee, index) => {
      return fee.id !== i;
    });
    setPPCFeesStructureDetail(remain);
  };
  const handleDeleteFee = (i) => {
    let remain = ppcFeesDetail.filter((fee, index) => {
      return fee.id !== i;
    });
    setPPCFeesDetail(remain);
  };
  const handleFeeChangeEnable = (enable, index) => {
    let newSEOFeeEnabled = ppcFeesDetail;
    newSEOFeeEnabled[index]["enabled"] = !enable;
    setPPCFeesDetail([...newSEOFeeEnabled]);
  };
  const handleChange = (field, index, value) => {
    let newArray = ppcFeesDetail;
    newArray[index][field] = value;
    setPPCFeesDetail([...newArray]);
  };

  return (
    <div>
      <CustomSwitch
        isEnabled={props.isEnabled}
        setIsEnabled={props.setIsEnabled}
        label={
          <p className="ppc-color pb-0 f28 visby-bold pl-3 mb-0" style={{ marginTop: "-5px" }}>
            PPC
          </p>
        }
        text="PPC"
        variant="ppc"
        customClass="d-inline-block"
        id="ppc-enable"
        checked={props.isEnabled}
      />
      <div style={{ display: props.isEnabled ? undefined : "none" }}>
        <Row className="d-flex">
          <Col className="d-flex flex-column agreement-col">
            <p className="agreement light-primary mb-3">Agreement</p>
            <div className="shared-fee-structure mb-5">
              <div className="table-responsive">
                <Table className="pb-3">
                  <thead>
                    <tr>
                      <th className="visby-bold f16 pb-3 light-primary">
                        <span>Select and set shared fee structure</span>{" "}
                        <CustomTooltip
                          faClass="far f18 light-primary fa-question-circle pl-2"
                          message="This is where you can dictate how a client will be charged based on their ad spend. You can set multiple thresholds for ad spend on the left, and then tell DataPulse whether you would like to charge a fixed dollar amount, or a percentage of that ad spend for each threshold with the boxes on the right. In the case of charging a percentage, you can also specify whether you would like to charge a percentage of the total ad spend, or only the percentage of the amount that is over the specified threshold."
                          inline={true}
                        />
                      </th>
                      <th style={{ paddingLeft: "40px" }} className=" nunito-regular light-primary f12">
                        Fixed Amount
                      </th>
                      <th style={{ paddingLeft: "35px" }} className="nunito-regular light-primary f12">
                        % of ad spend (total or above)
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {ppcFeesStructure.map((detail, index) => {
                      const flatFeeEnabled = detail["flat_fee_enabled"] == "1";
                      const percentageEnabled = detail["percentage_fee_enabled"] == "1";
                      const greyout1 = flatFeeEnabled ? null : { opacity: "0.6" };
                      const greyout2 = percentageEnabled ? null : { opacity: "0.6" };
                      return (
                        <tr key={detail.id ? detail.id : uuidv4()}>
                          <td>
                            <input type="hidden" name={`ppc_fee_structure[][id]`} value={detail.id} />
                            <div className="mr-2 input-box4">
                              Over ad spend
                              <Form.Control
                                size="sm"
                                name={`ppc_fee_structure[][over_ad_spend]`}
                                placeholder="0"
                                value={detail.over_ad_spend ? detail.over_ad_spend : 0}
                                onChange={(e) => {
                                  let newArray = ppcFeesStructure;
                                  newArray[index]["over_ad_spend"] = e.target.value;
                                  setPPCFeesStructureDetail([...newArray]);
                                }}
                                disabled={!props.isEnabled}
                              />
                              <span style={{ cursor: !props.isEnabled ? "default" : "text" }} className="unit">
                                $
                              </span>
                              <span style={{ paddingRight: "2px" }}>charge</span>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-items-center">
                              <div style={{ width: "16px" }} className="pr-0">
                                <CustomFormCheck
                                  name={`ppc_fee_structure[][flat_fee_enabled]`}
                                  id={`ppcagreecharge ` + `${index}`}
                                  checked={flatFeeEnabled}
                                  sendUncheckedValue={!flatFeeEnabled}
                                  onChange={() => {
                                    let newArray = ppcFeesStructure;
                                    newArray[index]["flat_fee_enabled"] = !flatFeeEnabled;
                                    setPPCFeesStructureDetail([...newArray]);
                                  }}
                                  disabled={!props.isEnabled}
                                />
                              </div>
                              <div className="input-box2">
                                <Form.Control
                                  size="sm"
                                  disabled={!flatFeeEnabled}
                                  style={greyout1}
                                  className="cw2"
                                  placeholder="0"
                                  name={`ppc_fee_structure[][flat_fee]`}
                                  value={detail ? detail.flat_fee : 0}
                                  onChange={(e) => {
                                    let newArray = ppcFeesStructure;
                                    newArray[index]["flat_fee"] = e.target.value;
                                    setPPCFeesStructureDetail([...newArray]);
                                  }}
                                />
                                <span style={{ cursor: !props.isEnabled ? "default" : "text", opacity: !flatFeeEnabled ? "0.6" : null }} className="unit">
                                  $
                                </span>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex pl-0  align-items-center">
                              <div style={{ width: "26px" }}>
                                <CustomFormCheck
                                  name={`ppc_fee_structure[][percentage_fee_enabled]`}
                                  id={`ppcagreerev ` + `${index}`}
                                  checked={percentageEnabled}
                                  sendUncheckedValue={!percentageEnabled}
                                  onChange={() => {
                                    let newArray = ppcFeesStructure;
                                    newArray[index]["percentage_fee_enabled"] = !percentageEnabled;
                                    setPPCFeesStructureDetail([...newArray]);
                                  }}
                                />
                              </div>
                              <Form.Control
                                className="ml-0 mr-0"
                                as="select"
                                size="sm"
                                name={`ppc_fee_structure[][percentage_fee_total_over]`}
                                placeholder="0"
                                defaultValue={detail ? detail.percentage_fee_total_over : 0}
                                disabled={!percentageEnabled}
                                style={greyout2}>
                                <option value="total">total</option>
                                <option value="over">partial</option>
                              </Form.Control>
                              <div className="input-box3">
                                <Form.Control
                                  disabled={!percentageEnabled}
                                  size="sm"
                                  style={{ width: "100px", marginLeft: "10px", marginRight: "20px", opacity: !percentageEnabled ? "0.6" : null }}
                                  name={`ppc_fee_structure[][percentage_fee]`}
                                  value={detail ? detail.percentage_fee : 0}
                                  placeholder="0"
                                  onChange={(e) => {
                                    let newArray = ppcFeesStructure;
                                    newArray[index]["percentage_fee"] = e.target.value;
                                    setPPCFeesStructureDetail([...newArray]);
                                  }}
                                />
                                <span style={{ cursor: !props.isEnabled ? "default" : "text" }} className="unit">
                                  %
                                </span>
                              </div>
                              {index >= 0 && ppcFeesStructure.length > 1 && (
                                <i
                                  className={!props.isEnabled ? "fas fa-minus-circle fa-disabled" : "fas fa-minus-circle"}
                                  onClick={(e) => {
                                    handleDeleteStructure(detail.id);
                                  }}></i>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
              <Button style={{ marginLeft: "11px" }} className="mt-3 btn-sm center-mobile-button" variant="success" onClick={handleAddStructure} disabled={!props.isEnabled}>
                + Add Condition
              </Button>
            </div>
            <div className="active-ppc-fees">
              <h4 className="d-inline-block light-primary pr-2 visby-bold">Active PPC Fees</h4>
              <h5 style={{ visibility: "hidden" }} className="d-inline-block ppc-color">
                View full history
              </h5>
              <div className="mb-5">
                <div className="table-responsive">
                  <Table className="pb-3">
                    <thead>
                      <tr>
                        <th></th>
                        <th className="pl-3">Frequency</th>
                        <th className="pl-3">Label</th>
                        <th className="pl-3">Amount</th>
                        <th style={{ visibility: "hidden" }}>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ppcFeesDetail.map((detail, index) => {
                        const ppcFeeEnabled = detail["enabled"] == "1";
                        const greyout = ppcFeeEnabled ? null : { opacity: "0.6" };

                        return (
                          <tr key={detail.id ? detail.id : uuidv4()}>
                            <td className="pr-0">
                              <div style={{ width: "26px" }}>
                                <CustomFormCheck
                                  name={`ppc_fees[][enabled]`}
                                  id={`activeppc ` + `${index}`}
                                  checked={ppcFeeEnabled}
                                  sendUncheckedValue={!ppcFeeEnabled}
                                  onChange={(e) => handleFeeChangeEnable(ppcFeeEnabled, index)}
                                  disabled={!props.isEnabled}
                                />
                                <input type="hidden" name={`ppc_fees[][id]`} value={detail.id} />
                              </div>
                            </td>

                            <td style={greyout} className="px-0">
                              <Form.Control
                                as="select"
                                size="sm"
                                name={`ppc_fees[][frequency]`}
                                defaultValue={detail ? detail.frequency : 0}
                                disabled={!ppcFeeEnabled}>
                                <option value="Monthly">Monthly</option>
                                <option value="One-time">One-time</option>
                              </Form.Control>
                            </td>
                            <td style={greyout} className="pr-0">
                              <Form.Control
                                size="sm"
                                className="ml-0 mr-1 cw1"
                                name={"ppc_fees[][label]"}
                                value={detail.label}
                                onChange={(e) => handleChange("label", index, e.target.value)}
                                disabled={!ppcFeeEnabled}
                              />
                            </td>
                            <td className="pl-0">
                              <div className="d-flex align-items-center">
                                <div className="input-box2 mr-2">
                                  <Form.Control
                                    style={{...greyout, width: "100px"}}
                                    size="sm"
                                    placeholder="0"
                                    name="ppc_fees[][amount]"
                                    value={detail.amount}
                                    onChange={(e) => handleChange("amount", index, e.target.value)}
                                    disabled={!ppcFeeEnabled}
                                  />
                                  <span style={{ cursor: !props.isEnabled ? "default" : "text", opacity: !ppcFeeEnabled ? "0.6" : null }} className="unit">
                                    $
                                  </span>
                                </div>
                                <div>
                                  <i className="fas fa-minus-circle" onClick={(e) => handleDeleteFee(detail.id)}></i>
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
                <Button style={{ marginLeft: "12px" }} className="center-mobile-button btn-sm mt-3" variant="success" onClick={handleAddPPCFee} disabled={!props.isEnabled}>
                  + Add fee
                </Button>
              </div>
            </div>
          </Col>
          <Col className="d-flex pl-lg-0 pl-3 flex-column">
            <PointsofContact {...props} group="ppc" />
          </Col>
        </Row>
      </div>
    </div>
  );
}
